export enum AggregateConditionType {
  Amount = 'Amount',
  Percentage = 'Percentage'
}
